// extracted by mini-css-extract-plugin
export default {"link":"ToastLink_link__f0NiK","url":"ToastLink_url__p4iR7","buttons":"ToastLink_buttons__EKHnT","button":"ToastLink_button__kRvjW"};